/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, Input } from "../../../components";
import {
  validateCharacterLength,
  validatePositiveValue,
  nameValidation2,
  numberValidation,
} from "../../../utilities/utils";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { toast } from "react-toastify";
import { CreateRentingProduct } from "../../../utilities/api/stock/rent";
import { useNavigate } from "react-router-dom";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.stocks;

const errorInit = {
  name: "",
  costPrice: "",
  rentingPrice: "",
  sacCode: "",
  totalQuantity: "",
  igst: "",
  cgst: "",
  sgst: "",
};

const AddServicesInventory = () => {
  const navigate = useNavigate();

  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const [submit, setSubmit] = useState<boolean>(false);
  const [data, setData] = useState({
    name: "",
    facilityId: "",
    costPrice: "",
    rentingPrice: "",
    sacCode: "",
    totalQuantity: 0,
    igst: "",
    cgst: "",
    sgst: "",
    isActive: "true",
  });
  const [error, setError] = useState({ ...errorInit });

  useEffect(() => {
    updateData("facilityId", SelectedFacility, false);
  }, [SelectedFacility]);

  const updateData = (
    key: any,
    value: any = "",
    checkValid: boolean = true
  ) => {
    if (typeof key === "object") {
      setData((oldSession) => ({ ...oldSession, ...key }));
    } else {
      setData((oldSession) => ({ ...oldSession, [key]: value }));
    }
  };
  useEffect(() => {
    if (submit) {
      isValid();
    }
  }, [updateData]);
  const isValid = () => {
    if (
      !data?.name ||
      nameValidation2(data?.name) == null ||
      !data?.cgst ||
      !data?.costPrice ||
      data?.costPrice.length > 10 ||
      numberValidation(data?.costPrice) == null ||
      Number(data?.costPrice) == 0 ||
      data?.rentingPrice.length > 10 ||
      numberValidation(data?.rentingPrice) == null ||
      !data?.rentingPrice ||
      data?.sacCode.length != 6 ||
      !data?.igst ||
      !data?.sgst ||
      numberValidation(Number(data?.igst)) == null ||
      numberValidation(Number(data?.cgst)) == null ||
      numberValidation(Number(data?.sgst)) == null ||
      !data?.totalQuantity
    ) {
      setError({
        name: data?.name
          ? nameValidation2(data?.name) == null
            ? getMessage.name_matches
            : ""
          : getMessage.name_required,
        costPrice: data?.costPrice
          ? data?.costPrice.length > 10
            ? getMessage.serviceCostPrice_maxLength
            : numberValidation(data?.costPrice) == null
              ? getMessage.serviceCostPrice_match
              : Number(data?.costPrice) > 0
                ? ""
                : getMessage.serviceCostPrice_minLength
          : getMessage.serviceCostPrice_required,
        rentingPrice: data?.rentingPrice
          ? data?.rentingPrice.length > 10
            ? getMessage.rentingPrice_maxLength
            : numberValidation(data?.rentingPrice) == null
              ? getMessage.rentingPrice_matches
              : ""
          : getMessage.rentingPrice_required,

        sacCode: data?.sacCode.length != 6 ? getMessage.sacCode_length : "",
        totalQuantity:
          Number(data?.totalQuantity) > 0
            ? data?.totalQuantity.toString().length > 4
              ? getMessage.totalQuantity_maxLength
              : ""
            : getMessage.serviceTotalQuantity_required,
        igst:
          Number(data?.igst) <= 0
            ? getMessage.IGST_required
            : numberValidation(Number(data?.igst)) != null
              ? ""
              : getMessage.IGST_valueType,
        cgst:
          Number(data?.cgst) <= 0
            ? getMessage.CGST_required
            : numberValidation(Number(data?.cgst)) != null
              ? ""
              : getMessage.CGST_valueType,
        sgst:
          Number(data?.sgst) <= 0
            ? getMessage.SGST_required
            : numberValidation(Number(data?.sgst)) != null
              ? ""
              : getMessage.SGST_valueType,
      });
      return false;
    }
    if (!SelectedFacility) {
      toast.error(getMessage.facilityID_required);
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setSubmit(true);
    if (isValid()) {
      let payload = {
        ...data,
        facilityId: Number(SelectedFacility),
        costPrice: Number(data?.costPrice),
        rentingPrice: Number(data?.rentingPrice),
        totalQuantity: Number(data?.totalQuantity),
        igst: Number(data?.igst),
        cgst: Number(data?.cgst),
        sgst: Number(data?.sgst),
      };
      const result = await CreateRentingProduct(payload);
      if (result?.status === 200) {
        toast.success(result?.message);
        navigate("/rent-stock");
      } else {
        toast.error(result.response.data.message);
      }
    }
  };


  const setValueWithLength = (key = "", value = "", min = 0, max = 0) => {
    if (validateCharacterLength(value, min, max)) {
      updateData(key, value);
    }
  };

  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, Number(value));
    }
  };

  const getPercentValue = (amount: number, percent: number) => {
    return (Number(amount) * Number(percent)) / 100;
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">Add Service Stock</Card.Title>
            </div>
            <hr />
            <Row>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="productname" className="form-label">
                    Product Name <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter Product Name"
                    id="productname"
                    name="productname"
                    className="form-control"
                    value={data?.name}
                    onChange={(e: any) => updateData("name", e?.target?.value)}
                  />
                  {error?.name && <div className="error-msg">{error?.name}</div>}
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="rentingPrice" className="form-label">
                    Charges per Unit for 30 Minutes <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={data?.rentingPrice}
                    type="text"
                    placeholder="Enter Charges"
                    id="rentingPrice"
                    name="rentingPrice"
                    className="form-control"
                    onChange={(e: any) => {
                      if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                        updateData("rentingPrice", e.target.value);
                      }
                    }}
                  />
                  {error?.rentingPrice && <div className="error-msg">{error?.rentingPrice}</div>}
                </div>
              </Col>

              <Col lg={4}>
                <div className="mb-3 text-start">
                  <label htmlFor="pvalue" className="form-label">
                    Product Value <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter Product Value"
                    id="pvalue"
                    name="pvalue"
                    className="form-control"
                    value={data?.costPrice}
                    onChange={(e: any) => {
                      if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                        updateData("costPrice", e.target.value);
                      }
                    }}
                  />
                  {error?.costPrice && <div className="error-msg">{error?.costPrice}</div>}
                </div>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col lg={4}>
                <div
                  className="mb-3 text-start"
                  style={{ position: "relative", paddingBottom: "1.2em" }}
                >
                  <label htmlFor="purchasedqty" className="form-label">
                    Purchased Quantity <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="number"
                    placeholder="Enter Purchased Quantity"
                    id="purchasedqty"
                    name="purchasedqty"
                    className="form-control"
                    value={data?.totalQuantity}
                    onChange={(e: any) => {
                      if (e.target.value == "") {
                        setPositiveValue("totalQuantity", e?.target?.value);
                      }
                      if (/^\d+$/.test(e.target.value)) {
                        setPositiveValue("totalQuantity", e?.target?.value);
                      }
                    }}
                  />
                  {error?.totalQuantity && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>
                      {error?.totalQuantity}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={4} className="mb-3 text-start">
                <div className="badge bg-info fs-6 fst-italic fw-semibold mb-0 mb-3 p-2 text-nowrap">
                  Value of Available Stock: <span className="rupees-symbol">&#8377;</span>{" "}
                  {(Number(data?.costPrice) * Number(data?.totalQuantity))?.toFixed(2)}
                </div>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col lg={2}>
                <div
                  className="mb-3 text-start"
                  style={{ position: "relative", paddingBottom: "1.2em" }}
                >
                  <label htmlFor="sac" className="form-label">
                    SAC Number <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter SAC Number"
                    id="sac"
                    name="sac"
                    className="form-control"
                    value={data?.sacCode}
                    onChange={(e: any) => {
                      if (Number(e?.target?.value) >= 0)
                        setValueWithLength("sacCode", e?.target?.value, 0, 6);
                    }}
                    onKeyDown={(e: any) => e.key === "." && e.preventDefault()}
                  />
                  {error?.sacCode && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>
                      {error?.sacCode}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div
                  className="mb-3 text-start"
                  style={{ position: "relative", paddingBottom: "1.2em" }}
                >
                  <label htmlFor="i-gst" className="form-label">
                    IGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter IGST"
                    id="i-gst"
                    name="i-gst"
                    className="form-control"
                    value={data?.igst}
                    onChange={(e: any) => {
                      const igst = e?.target?.value;
                      if (igst >= 0 && igst <= 100) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          cgst: `${igst / 2}`,
                          sgst: `${igst / 2}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.igst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>
                      {error?.igst}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div
                  className="mb-3 text-start"
                  style={{ position: "relative", paddingBottom: "1.2em" }}
                >
                  <label htmlFor="cgst" className="form-label">
                    CGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter CGST"
                    id="c-gst"
                    name="c-gst"
                    className="form-control"
                    value={data?.cgst}
                    onChange={(e: any) => {
                      const cgst = e?.target?.value;
                      const igst = Number(cgst) + Number(data?.sgst);
                      if (igst >= 0 && igst <= 100 && cgst >= 0) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          cgst: `${cgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.cgst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>
                      {error?.cgst}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div
                  className="mb-3 text-start"
                  style={{ position: "relative", paddingBottom: "1.2em" }}
                >
                  <label htmlFor="s-gst" className="form-label">
                    SGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter SGST"
                    id="s-gst"
                    name="s-gst"
                    className="form-control"
                    value={data?.sgst}
                    onChange={(e: any) => {
                      const sgst = e?.target?.value;
                      const igst = Number(sgst) + Number(data?.cgst);
                      if (igst >= 0 && igst <= 100 && sgst >= 0) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          sgst: `${sgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.sgst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>
                      {error?.sgst}
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={4} className="mb-3 text-start">
                <div className="badge bg-info fs-6 fst-italic fw-semibold mb-0 mb-3 p-2 text-wrap text-start">
                  Service Charges Per 30 Minutes:{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {(
                      Number(data?.rentingPrice) +
                      getPercentValue(Number(data?.rentingPrice), Number(data?.igst))
                    )?.toFixed(2)}
                  </span>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <Button
                  type="button"
                  bname="Submit"
                  name="submit"
                  id="submit"
                  className="btn btn-primary rounded-1"
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { AddServicesInventory };
